import { createApp, watch } from "vue";
import { ngFrameworkLoaded } from "@sazka/ng/ng-integration";
import { useWecomaIntegration } from "@sazka/utils/gdpr/use-wecoma-integration";
import ConsentBar from "@sazka/utils/gdpr/consent-bar.vue";
import { useNgSession } from "@sazka/ng/ng-session";
import { WecomaConstants } from "@sazka/utils/gdpr/wecoma-constants";
import { wecomaRedirectActive } from "@sazka/utils/gdpr/use-wecoma-redirect";
import { eventBus, GlobalEvents } from "@sazka/utils/global-events";

// eslint-disable-next-line
let loaded = false;

async function init() {
    if (loaded) return;

    loaded = true;

    await initConsentBar();

    if (wecomaRedirectActive) {
        await ngFrameworkLoaded();
        const { isLoggedIn } = useNgSession();
        if (isLoggedIn.value) {
            await openConsetsCenter("_self");
            return;
        }

        const watcherStop = watch(isLoggedIn, async (newVal) => {
            if (newVal) {
                await openConsetsCenter("_self");
            }
        });

        eventBus.on(GlobalEvents.WebLoginAborted, () => {
            watcherStop();
        });
    }
}

async function initConsentBar() {
    try {
        if (environment.hideConsentBar) {
            return;
        }

        const { shouldCookieBarOpen } = useWecomaIntegration();
        if (!(await shouldCookieBarOpen())) return;

        const component = createApp(ConsentBar);

        const root = document.createElement("div");
        document.body.appendChild(root);
        component.mount(root);
    } catch (e) {
        console.error("error while initializng consent bar", e);
    }
}

async function openConsetsCenter(target: "_self" | "_blank" = "_blank") {
    window.open(await getLinkToPrefCenter(), target);
}

async function getLinkToPrefCenter(): Promise<string> {
    const domain = appSettings["Integrations:Wecoma:Domain"];

    const link = `${domain}?locale=cs-CZ&key=${WecomaConstants.WECOMA_CODE_DEH}`;

    const { canBeLoggedInWecoma, getWecomaKeysValue } = useWecomaIntegration();

    if (canBeLoggedInWecoma()) {
        const wecomaKeys = await getWecomaKeysValue();
        if (wecomaKeys) {
            return link + `&authKeys=${wecomaKeys.wecomaUserKey}`;
        }
    }

    return link;
}

export function useGdpr() {
    return {
        init,
        getLinkToPrefCenter,
    };
}
